function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.25 5.15v2.7c0 1.84-.56 2.4-2.4 2.4h-2.7c-1.84 0-2.4-.56-2.4-2.4v-2.7c0-1.84.56-2.4 2.4-2.4h2.7c1.84 0 2.4.56 2.4 2.4zm-11 11v2.7c0 1.84-.56 2.4-2.4 2.4h-2.7c-1.84 0-2.4-.56-2.4-2.4v-2.7c0-1.84.56-2.4 2.4-2.4h2.7c1.84 0 2.4.56 2.4 2.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.15 11.75a.48.48 0 01.48.48v1.39c0 2.28-.73 3.01-3.01 3.01h-1.39a.48.48 0 01-.48-.48c0-2.66-1.24-3.9-3.9-3.9a.48.48 0 01-.48-.48v-1.39c0-2.28.73-3.01 3.01-3.01h1.39a.48.48 0 01.48.48c0 2.66 1.24 3.9 3.9 3.9z"
})));